const Background = () => {
  return (
    <>
      <div className='w-[400px] h-[400px] bg-dark dark:bg-light absolute top-[50%] left-[70%] blur-[40px] z-0 opacity-[0.15] rounded-full'></div>
      <div className='w-[400px] h-[400px] bg-dark dark:bg-light absolute top-[20%] left-[20%] blur-[40px] z-0 opacity-[0.15] rounded-full'></div>
    </>
  );
};

export default Background;
